<template>
  <div class="xiabiao">
    
    <div class="kuang">
        <div class="left">
            <h1 class="company">浙江固德医药有限公司</h1>
            <p>地址：浙江省温州市洞头区北岙街道溢香路86号B幢</p>
            <p>邮编：325700</p>
            <p>电话：0577-88125111</p>
            <p>网址：www.goodyiyao.com</p>
        </div>
        <div class="two">
        <div class="center">
            <h1 class="title">企业概况</h1>
            <router-link :to="{name:'gdyy'}">企业简介</router-link>
            <router-link :to="{name:'zzjg'}">组织结构</router-link>
            <router-link :to="{name:'zlfz'}">企业文化</router-link>
            <router-link :to="{name:'contactus'}">关于我们</router-link>
        </div>
        <div class="right">
            <h1 class="title">企业动态</h1>
            <router-link :to="{name:'qyxw'}">企业新闻</router-link>
            <router-link :to="{name:'gsgg'}">通知公告</router-link>
            <router-link :to="{name:'hyxw'}">行业动态</router-link>
            <router-link :to="{name:'flfg'}">法律法规</router-link>
        </div>
    </div>
        <div class="wx"><img src="../assets/images/qrcode.jpg" style="width: 150px;height: 150px;"></div>
        <!-- <img src="../assets/images/goodlogo.png" class="logoo"> -->
    </div>

  </div>
</template>
<script>
export default {
    data() {
        return {

        }
    }
}
</script>
<style scoped>
    .xiabiao{
        background-color: #f6fdf4;
        max-width: 100vw;
        width: 100%;
        margin: 0 auto;
        overflow:hidden;
    }
    .kuang{
        white-space:nowrap;
        max-width: 1200px;
        height: auto;
        display: flex;
        margin: 0 auto;
        overflow:hidden;
    }
    .left{
        width: 450px;
        height: 350px;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        }
    .company{
        color:#76bd25;
        font-size: 2rem;
        font-weight: bolder;
        margin-bottom: 40px;
    }
    .left p{
        margin-bottom: 20px;
        font-size: 1rem;
    }
    .center{
        height: 350px;
        width: 300px;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .right{
        height: 350px;
        width: 300px;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .left, .center, .right {
        flex: 1 1 30%; /* 让每个部分至少占据30%的宽度，但可以增长和缩小 */
        box-sizing: border-box;
    }
    .title{
        font-size: 20px;
        font-weight: bolder;
        margin-bottom: 30px;
    }
    a{
        text-decoration: none;
        color: #272727;
        margin-bottom: 17px;
        font-size: 1rem;
    }
    .wx{
        width: 400px;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        align-items:flex-end;
        background: url("../assets/images/goodlogo.png") no-repeat; /* 设置背景图片 */
        background-size: contain; /* 确保背景图片按比例缩放 */
        background-position: right bottom; /* 调整背景图片的位置 */
    }
    
    /* 如果需要在较小屏幕上隐藏背景图或做其他调整 */
    @media (max-width: 1200px){
        .wx {
            background-size: 250px auto; /* 调整大小 */
            background-image: none; /* 在小屏幕上不显示背景图 */
            align-items:baseline;
            padding-left: 50px;
            max-width: 150px;
        }
        .kuang {
            flex-direction: column; /* 在较小屏幕上垂直排列 */
        }

        .left{
            padding-top: 40px;
            padding-left: 50px;
        }
        .center{
            align-items:baseline;
            padding-left: 50px;
        }
        .right{
            align-items:baseline;
            padding-left: 50px;
        }
        .left, .center, .right, .wx {
            width: 100%; /* 占满整个宽度 */
            margin-bottom: 20px;
        }
        .company {
        font-size: 1.5rem; /* 在小于800px宽的屏幕上使用的字体大小 */
        }

        .left p, a {
            font-size: 0.8rem;
        }
        .two{
            display: flex;
        }
}

@media (max-width: 500px) {
    .wx{
        max-width: 150px;
    }
    .company {
        font-size: 1.2rem; /* 在小于480px宽的屏幕上使用的字体大小 */
    }

    .left p, a {
        font-size: 0.7rem;
    }
}
</style>